export const customerSupport = {
    title: "Welcome to Picadeli customer support",
    contactUs: "Contact us",
    openingHours: "Opening hours",
    email: "Email: {{value}}",
    phone: "Phone: {{value}}",
    openingHoursStart: "Opens at: {{value}}",
    openingHoursEnd: "Closes at: {{value}}",
};
